import * as React from "react";
import { useCreatePath, useRedirect, useResourceContext } from "react-admin";
import { Button, Box, Paper, Stack, Typography } from "@mui/material";
import { layout } from "../../layout";

type EmptyStateProps = {
  title: string;
  hint?: string;
  createLabel?: string;
  hasCreate?: boolean;
  actions?: React.ReactNode;
};

export function EmptyState({
  title,
  hint,
  createLabel = "Neu anlegen",
  hasCreate = true,
  actions,
}: EmptyStateProps) {
  const resource = useResourceContext();
  const createPath = useCreatePath();
  const redirect = useRedirect();

  const defaultCreateAction = hasCreate ? (
    <Button
      variant="contained"
      onClick={() => redirect(createPath({ resource, type: "create" }))}
      sx={{ alignSelf: "flex-start" }}
    >
      {createLabel}
    </Button>
  ) : null;

  return (
    <Box
      sx={{
        pt: { xs: 5, sm: 5 },
        display: "flex",
        justifyContent: { xs: "flex-start", lg: "center" },
      }}
    >
      <Paper
        variant={layout.card.variant}
        elevation={layout.card.elevation}
        sx={{
          width: { xs: "100%", lg: layout.edit.formWidth },
          maxWidth: "100%",
          p: layout.card.padding,
          borderRadius: layout.card.radius,
          boxShadow: "none",
          backgroundImage: "none",
        }}
      >
        <Stack spacing={2.5}>
          <Stack spacing={0.75}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {title}
            </Typography>

            {hint ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ maxWidth: 560 }}
              >
                {hint}
              </Typography>
            ) : null}
          </Stack>

          {actions ?? defaultCreateAction}
        </Stack>
      </Paper>
    </Box>
  );
}
